import React from 'react'
import CheckSvg from './svgr/Check'
import { Button } from 'react-bootstrap'

const DoneMessage = () => {
  return (
      <div className='done-info'>
        <div className='success-icon'>
          <CheckSvg />
        </div>
        <h3>Processing Complete!!!</h3>
        <p>Your questions are categorized and ready for you to view.</p>
        <Button variant='primary' className='w-100'>Show Data Table</Button>
      </div>
  )
}

export default DoneMessage